export default __webpack_public_path__ + "static/media/40.9986645f.jpeg";